import React from "react";
import styles from "./contact_us.module.css";


function ContactHero({t}) {
  
  return (
    <div className={styles.contact_hero}>
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
        }}
      >
        <img
          style={{
            width: "100%",
            height: "110%",
            zIndex: `-1`,
            position: "absolute",
          }}
          src="/contact_bg.png"
          alt=""
        />
        <div className={styles.ContactLabel}>
          <div className={styles.ContactLabelCont}>
            <h1>{t('get_in_touch')}</h1>
            <h1>{t('banknote_here')}</h1>
            <h1>
               {t('to')}<span style={{ color: "#E4C78B" }}>{t('help_your')}</span>
            </h1>
            <h1 style={{ color: "#E4C78B" }}>{t('business')}</h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactHero;
